import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import PieCard from '../PieCard/PieCard';
import PieChartPlaceholder from '../../chartsPlaceholders/PieCardPlaceholder/PieCardPlaceholder';
import CallsInfoSkeleton from '../../skeletons/CallsInfoSkeleton/CallsInfoSkeleton';
import IsCountingBlock from '../../IsCountingBlock/IsCountingBlock';
import styles from './PieCardChart.module.scss';

const PieCardChart = ({
  title,
  style,
  className,
  data = [],
  loading = false,
  colors,
  onItemClick,
  isActiveItem,
  marksChart = false,
  renderContent,
  valueKey = 'value',
}) => {
  const isCounting = useSelector((state) => state.statisticsStore.isCounting);

  if (loading) {
    return <CallsInfoSkeleton className={className} style={style} />;
  }

  if (!loading && !isCounting && data.every((item) => item.value === 0)) {
    return (
      <PieChartPlaceholder
        title={title}
        marksChart={marksChart}
        className={className}
        style={style}
      />
    );
  }

  return (
    <div className={cn(styles.chart, className)} style={style}>
      <IsCountingBlock spinning={isCounting}>
        <div className={styles.title}>{title}</div>
        <PieCard
          onItemClick={onItemClick}
          data={data}
          isActiveItem={isActiveItem}
          colors={colors}
          renderContent={renderContent}
          valueKey={valueKey}
        />
      </IsCountingBlock>
    </div>
  );
};

export default PieCardChart;
